import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { useLang } from '../lib/i18n/LanguageContext';
import { dictionary } from '../lib/i18n/dictionary';
import { GridPattern } from '../components/graphics/GridPattern';
export function AboutPage() {
  const {
    lang
  } = useLang();
  const t = dictionary.about;
  const c = dictionary.common;
  return <main className="bg-white" data-id="element-679">
      {/* Hero */}
      <section className="relative pt-32 pb-20 bg-navy-deep overflow-hidden" data-id="element-680">
        <div className="absolute inset-0 tech-grid opacity-50" aria-hidden="true" data-id="element-681" />
        <GridPattern className="absolute inset-0 text-gold/30 opacity-20" data-id="element-682" />
        <div className="relative max-w-4xl mx-auto px-5 md:px-8" data-id="element-683">
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-684">
            <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-gold mb-4" data-id="element-685">
              {t.eyebrow[lang]}
            </p>
            <h1 className="font-serif text-white text-4xl md:text-5xl leading-[1.1] tracking-tight" data-id="element-686">
              {t.title[lang]}
            </h1>
            <p className="mt-6 text-slate-300 text-lg leading-relaxed max-w-3xl" data-id="element-687">
              {t.intro[lang]}
            </p>
          </motion.div>
        </div>
      </section>

      {/* Mission */}
      <section className="py-20 md:py-24" data-id="element-688">
        <div className="max-w-4xl mx-auto px-5 md:px-8" data-id="element-689">
          <SectionHeading eyebrow={t.missionTitle[lang]} title={t.missionBody[lang]} data-id="element-690" />
        </div>
      </section>

      {/* Values */}
      <section className="py-20 md:py-24 bg-slate-50" data-id="element-691">
        <div className="max-w-7xl mx-auto px-5 md:px-8" data-id="element-692">
          <SectionHeading eyebrow={t.valuesTitle[lang]} title={t.valuesTitle[lang]} data-id="element-693" />
          <div className="mt-12 grid md:grid-cols-2 gap-5" data-id="element-694">
            {t.values[lang].map((v, i) => <Card key={v.title} delay={i * 0.06} className="p-7" data-id="element-695">
                <span className="font-serif text-3xl text-gold-deep" data-id="element-696">
                  0{i + 1}
                </span>
                <h3 className="font-serif text-xl text-navy-deep mt-3 mb-2" data-id="element-697">
                  {v.title}
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-698">{v.body}</p>
              </Card>)}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-white" data-id="element-699">
        <div className="max-w-3xl mx-auto px-5 md:px-8 text-center" data-id="element-700">
          <h2 className="font-serif text-3xl text-navy-deep mb-6" data-id="element-701">
            {dictionary.finalCta.title[lang]}
          </h2>
          <div className="flex flex-wrap justify-center gap-3" data-id="element-702">
            <Link to="/contact" data-id="element-703">
              <Button variant="gold" size="lg" data-id="element-704">
                {c.scheduleCall[lang]}
              </Button>
            </Link>
            <Link to="/suppliers" data-id="element-705">
              <Button variant="ghost" size="lg" data-id="element-706">
                {dictionary.footer.links.suppliers[lang]}
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </main>;
}